const translations = {
    amountFieldPlaceholder: 'Amt',
    descriptionFieldPlaceholder: 'Description',
    quantityFieldPlaceholder: 'Qty',
    rateFieldPlaceholder: 'Rate',
    serviceFieldPlaceholder: 'Service',
    taxFieldPlaceholder: 'Tax'
};

export default translations;
